// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"252":"6bd3cb8b","563":"6c9ed61e","684":"b357819d","829":"92fae80e"}[chunkId] + ".chunk.js";
};